const projects = [
    {
        name: "Green Glimpse",
        description:
            "A comprehensive tool for analyzing and visualizing the complete emissions footprint across a company's operations chain, from raw material sourcing to product delivery. Utilizing AI, IoT, and 5G for real-time, transparent carbon tracking.",
        image: ["img/GG2.png", "img/GG1.png"],
        imgLayout: "website",
        github: "https://github.com/MFarabi619/GreenGlimpse",
    },
    {
        name: "Life Counter App",
        description:
            "Mobile app built with react native used to keep track of life totals for a card game, has 2 different layouts with player customization.",
        image: ["img/LCA4.png", "img/LCA1.png", "img/LCA3.png", "img/LCA4.png"],
        imgLayout: "mobile",
        github: "https://github.com/Mango932/LifeCounterMTG",
    },
    {
        name: "Personal Website",
        description:
            "Website built using react framework with responsive mobile and computer layout with scroll and hover animations. Used the react Node.js for the backend and Netlify to deploy the application",
        image: ["img/Personal1.png", "img/Personal2.png", "img/Personal3.png"],
        imgLayout: "website2",
        github: "https://github.com/Mango932/personalwebsite",
    },
];

export default projects;
